import { compassUserPermissions, Roles as aclRoles, } from 'constants/accessControlList';
import { useFlagValue } from 'flagging/hooks';
import { useMemo, useState } from 'react';
import { useToken } from 'shared/hooks';
export var overrideTokenRolesWithLDForTesting = function (scopesFromToken) {
    var _a = useState(false), warned = _a[0], setWarned = _a[1];
    var testingFlagValues = useFlagValue('TEST_ROLES');
    if (testingFlagValues && Array.isArray(testingFlagValues) && testingFlagValues.length > 0) {
        if (!warned) {
            setWarned(true);
            // eslint-disable-next-line no-console
            console.warn('USING ROLES FROM LAUNCHDARKLY: ', testingFlagValues);
        }
        return testingFlagValues;
    }
    return scopesFromToken;
};
var canI = function (acl) {
    return function (
    /** what we want to do with it (or an array of things we want to do.) */
    actions, 
    /** The thing we want to mess with. */
    sub) {
        var _a;
        if (Array.isArray(actions)) {
            return actions.every(function (action) { var _a; return (_a = acl[sub]) === null || _a === void 0 ? void 0 : _a.includes(action); });
        }
        return ((_a = acl[sub]) === null || _a === void 0 ? void 0 : _a.includes(actions)) || false;
    };
};
/**
 * Provides a centralized source for Role Based Access Control in the front end code.
 * Access Control list is in ../../constants/accessControlList.ts for now, but it may
 * Move to a more centralized location in the near future.
 */
export var useRbac = function () {
    var scopes = (useToken() || { scopes: [] }).scopes;
    var roles = overrideTokenRolesWithLDForTesting(scopes);
    return useMemo(function () {
        var access = roles.reduce(function (out, role) {
            // only operate on enum roles we recognize
            if (Object.values(aclRoles).includes(role)) {
                // merge the subjects and actions together to distill a final list given all their roles
                Object.entries(compassUserPermissions[role] || {}).forEach(function (_a) {
                    var key = _a[0], actions = _a[1];
                    if (!out[key]) {
                        out[key] = [];
                    }
                    actions.forEach(function (a) {
                        var _a, _b;
                        // push the action on if they haven't heard of it yet.
                        if (!((_a = out[key]) === null || _a === void 0 ? void 0 : _a.includes(a))) {
                            (_b = out[key]) === null || _b === void 0 ? void 0 : _b.push(a);
                        }
                    });
                });
            }
            return out;
        }, {});
        return {
            roles: roles,
            access: access,
            /** Whether the current user can do something to a subject part of the application */
            canI: canI(access),
        };
    }, [roles.sort().join('')]);
};
